import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import type { Nil } from '@pbt/pbt-ui-components'

import { getUser } from '~/store/reducers/users'

import styles from './ClientNotes.module.scss'

interface ClientNotesProps {
  clientId: string | Nil
}

export const ClientNotes = ({ clientId }: ClientNotesProps) => {
  const client = useSelector(getUser(clientId))
  const { t } = useTranslation('Common')
  return (
    <div className={styles.clientNotesContainer}>
      <h4 className={styles.sectionTitle}>{t('Common:CLIENT_NOTES')}</h4>
      <div className={styles.notes}>{client?.notes}</div>
    </div>
  )
}
